import { Phone, MapPin, Mail } from 'lucide-react';

const footerLinks = {
  services: [
    { label: 'Residential Cleaning', href: '#services' },
    { label: 'Commercial & Office', href: '#services' },
    { label: 'Carpet Cleaning', href: '#services' },
    { label: 'Pressure Washing', href: '#services' },
    { label: 'Move-In / Move-Out', href: '#services' },
    { label: 'Disinfection Services', href: '#services' },
  ],
  company: [
    { label: 'About Us', href: '#about' },
    { label: 'Why Choose Us', href: '#why-us' },
    { label: 'Reviews', href: '#reviews' },
    { label: 'Contact', href: '#contact' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-axis-950 text-white pt-20 pb-8">
      <div className="max-w-7xl mx-auto section-padding">
        {/* Top Section */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 pb-12 border-b border-white/10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <img
                src="/logo.png"
                alt="AXIS Cleaning Services Logo"
                className="w-12 h-12 rounded-xl object-contain shadow-lg shadow-axis-500/20"
              />
              <div>
                <div className="font-display text-xl font-semibold">AXIS</div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-axis-400">Cleaning Services</div>
              </div>
            </div>
            <p className="text-axis-300/60 text-sm leading-relaxed mb-6">
              Dedicated to delivering reliable, professional cleaning for your home and office. Making your house a home since day one.
            </p>
            <div className="space-y-3">
              <a href="tel:2407509535" className="flex items-center gap-3 text-sm text-axis-300/60 hover:text-white transition-colors">
                <Phone className="w-4 h-4" />
                240-750-9535
              </a>
              <div className="flex items-start gap-3 text-sm text-axis-300/60">
                <MapPin className="w-4 h-4 mt-0.5" />
                <span>481 N Frederick Ave, Suite 412<br />Gaithersburg, MD 20877</span>
              </div>
            </div>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-white mb-5">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.href}
                    className="text-sm text-axis-300/60 hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-white mb-5">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.href}
                    className="text-sm text-axis-300/60 hover:text-white transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-white mb-5">Get Started</h4>
            <p className="text-sm text-axis-300/60 mb-5 leading-relaxed">
              Ready for a cleaner space? Contact us for a free estimate today.
            </p>
            <a
              href="#contact"
              className="inline-flex items-center justify-center clean-gradient text-white px-6 py-3 rounded-full text-sm font-semibold shadow-lg shadow-axis-500/20 hover:shadow-axis-500/40 hover:scale-105 transition-all duration-300"
            >
              Request Estimate
            </a>
            <div className="mt-6 flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
              <span className="text-xs text-axis-300/50">Available for new clients</span>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8">
          <p className="text-xs text-axis-300/40">
            &copy; {new Date().getFullYear()} AXIS Cleaning Services, LLC. All rights reserved.
          </p>
          <div />
        </div>
      </div>
    </footer>
  );
}
